/* @flow */
/**
 * index.js
 * Written by: Alex Kasemir
 */

import * as get from './getNotifications';
import * as view from './viewNotifications';
import * as click from './clickNotification';

export default {
  ...get,
  ...view,
  ...click,
};
